export const RENTAL_GUARANTEE_TYPE = Object.freeze({
  STANDALONE: 'STANDALONE',
  THIRD_PARTY_GUARANTEE: 'THIRD_PARTY_GUARANTEE',
});

export const RENTAL_ADMINISTRATOR_TO_GUARANTEE_TYPE_MAP = Object.freeze({
  OWNER: RENTAL_GUARANTEE_TYPE.STANDALONE,
  THIRD_PARTY: RENTAL_GUARANTEE_TYPE.THIRD_PARTY_GUARANTEE,
});
